import { memo, useState, useEffect } from 'react'
import { Box, Flex } from '@chakra-ui/react'
import DsrDisplayTeamAvatar from '../dsr-team-mgmt/DsrDisplayTeamAvatar'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import '../../layout/components/header/styles/header.scss';
import DsrManageOrgLogosModule from '../dsr-draft/DsrManageOrgLogosModule';
import StaticDsrHeaderMobileDisplay from './StaticDsrHeaderMobileDisplay'
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton'
import { displayReactIcon } from '../helpers/dsr-display-helpers'
import { redirectToNewPage } from '../../global/helpers/global-helpers'
import useLaunchdeckModal from '../../global/hooks/use-launchdeck-modal'
import DsrHeaderMoreOptionsButton from './DsrHeaderMoreOptionsButton'
import { setIsReadingMode } from '../actions/dsr-actions'

// Component holding other authentication components
function StaticDsrHeader({
	dsrTeamMembers,
	isLoggedInUser,
	// Action
	setIsReadingMode,
	// Redux
	isMobileView,
	dsrTitleRedux,
	dsrPropertiesRedux,

	isReadingMode,
}) {

	const [largeLogoDisplay, setLargeLogoDisplay] = useState(false)
	const { openLaunchdeckModal } = useLaunchdeckModal();

	useEffect(() => {
		if (dsrPropertiesRedux.logoDisplayOption === "large-logos" || dsrPropertiesRedux.logoDisplayOption === "nametag") {
			setLargeLogoDisplay(true)
		} else if (dsrPropertiesRedux.logoDisplayOption === "default") {
			setLargeLogoDisplay(false)
		}
	}, [dsrPropertiesRedux.logoDisplayOption]);

	const handleOnClick = () => {
		if (isLoggedInUser) {
			openLaunchdeckModal("show-add-logged-in-user-prompt")
		} else {
			openLaunchdeckModal("show-signup-login-prompt")
		}
	}

	if (isMobileView) {
		return (
			<StaticDsrHeaderMobileDisplay currentDsrTitle={dsrTitleRedux} />
		)
	} else {
		return (
			<>
				<Flex className='dsr-header__section-guest-version'>
					{dsrTitleRedux &&
						<Flex className='dsr-header__container' alignItems='center'>
							<>
								<Flex align='center'>
									<Box mr='1em' />
									<Flex align='center'>
										<Flex align='center'>
											{isLoggedInUser &&
												<Flex color='white' align='center' cursor='pointer' onClick={() => redirectToNewPage('/home')}>
													{displayReactIcon('back-arrow')}
													{/* <Box>Back</Box> */}

												</Flex>
											}
											<Box ml={isLoggedInUser ? '1.5em' : '0'} mr='1.5em'>
												<DsrManageOrgLogosModule logoDisplayMode={dsrPropertiesRedux.logoDisplayOption === "nametag" ? 'nametag' : 'default-dsr'} logoSize={largeLogoDisplay && '3.5em'} />
											</Box>

										</Flex>
										<Flex fontWeight='600' fontSize='1.25em' lineHeight='1.875em' color='white'>{dsrTitleRedux} </Flex>
									</Flex>
								</Flex>

								<Flex align='center'>
									<Flex>
										<Box><DsrDisplayTeamAvatar perspective='seller' dsrTeamMembers={dsrTeamMembers} /></Box>
										<Box><DsrDisplayTeamAvatar perspective='buyer' dsrTeamMembers={dsrTeamMembers} /></Box>
									</Flex>

									<Box rounded='0.25em'>
										<LaunchdeckButton label='Join Room' width='100%' bg='brand.500' color='white' onClick={() => handleOnClick()} />
									</Box>

									<Box ml='1em'>
										<DsrHeaderMoreOptionsButton
											setIsReadingMode={setIsReadingMode}
											isReadingMode={isReadingMode}
											isDsrAdmin={false}
										/>
									</Box>
								</Flex>
							</>
						</Flex>
					}
				</Flex>
			</>
		);


	}
}

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			setIsReadingMode,
		},
		dispatch,
	)

const mapStateToProps = (state) => ({
	dsrTitleRedux: state.dsrTitle.title,
	isMobileView: state.mobileViewMode.isMobileView,
	isReadingMode: state.isReadingMode.results
})


export default memo(withRouter(connect(mapStateToProps, mapDispatchToProps)(StaticDsrHeader)))

